import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Feature } from "./Feature";
import { useFeatures } from ".";
import { ExpandableText } from "@/components/utilsComponents";
import { MAX_FEATURES_PREVIEW_COUNT } from "./constants";
export const FeaturesPreview = () => {
    const features = useFeatures();
    if (!features)
        return null;
    const { preview, previewCount, additionalText, detailsCount } = features;
    const MAX_ADDITIONAL_TEXT_LINES = 8;
    if (previewCount === 0) {
        if (!additionalText)
            return null;
        return (_jsx(ExpandableText, { avZone: "classified_feature_details", text: additionalText, nbLines: MAX_ADDITIONAL_TEXT_LINES, withGradient: true }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Box, { as: "ul", display: "grid", gridTemplateColumns: {
                    "breakpoint.base": "repeat(1, 1fr)",
                    "breakpoint.sm": `repeat(${previewCount > 0 ? "2" : "1"}, 1fr)`,
                }, gap: "spacing.16", paddingLeft: "spacing.none", unsafe_className: "FeaturesPreview", children: preview.map((feature) => (_jsx(Box, { as: "li", unsafe_style: { listStyleType: "none" }, children: _jsx(Feature, { feature: feature }) }, feature.value))) }), detailsCount <= MAX_FEATURES_PREVIEW_COUNT && additionalText && (_jsx(ExpandableText, { avZone: "classified_feature_details", text: additionalText, nbLines: MAX_ADDITIONAL_TEXT_LINES, withGradient: true }))] }));
};
